import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { CircleIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

function RadioGroup({ className, ...props }) {
    return <RadioGroupPrimitive.Root data-slot="radio-group" className={cn('tw:grid tw:gap-3', className)} {...props} />
}

function RadioGroupItem({ className, ...props }) {
    return (
        <RadioGroupPrimitive.Item
            data-slot="radio-group-item"
            className={cn(
                'tw:border-blue-300 tw:text-primary tw:focus-visible:border-ring tw:focus-visible:ring-ring/50 tw:aria-invalid:ring-destructive/20',
                'tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive tw:dark:bg-input/30 tw:aspect-square tw:size-4 tw:shrink-0',
                'tw:!rounded-full tw:border tw:shadow-xs tw:transition-[color,box-shadow] tw:outline-none tw:focus-visible:ring-[3px]',
                'tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:focus-visible:!bg-blue-300',
                'tw:data-[state=checked]:!bg-blue-300',
                className,
            )}
            {...props}
        >
            <RadioGroupPrimitive.Indicator
                data-slot="radio-group-indicator"
                className="tw:relative tw:!flex tw:items-center tw:justify-center tw:hidden tw:bg-blue-300"
            >
                <CircleIcon className="tw:fill-white tw:absolute tw:top-1/2 tw:left-1/2 tw:size-2 tw:-translate-x-1/2 tw:-translate-y-1/2 tw:stroke-white" />
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
    )
}

export { RadioGroup, RadioGroupItem }
